import React from 'react';
import { DOCIcon, VideoIcon } from '../../../../utils/svg';
import { SharedImage } from '../../../../components/views/reports/modal/ImageModal';

const DocumentsTypes = [
  'doc',
  'docx',
  'xls',
  'xlsx',
  'pdf',
  'vnd.openxmlformats-officedocument.wordprocessingml.d',
  'msword',
  'vnd.ms-powerpoint',
  'vnd.openxmlformats-officedocument.presentationml.presentation',
  'vnd.openxmlformats-officedocument.presentationml.pre',
  'vnd.openxmlformats-officedocument.wordprocessingml.document'
];
const AudioTypes = ['opus', 'amr', 'mp3', 'm4a', 'ogg', 'aac', 'mpeg'];
const ImageTypes = ['jpeg', 'png', 'webp'];
const VideoTypes = ['mp4', 'webm', 'mov', 'avi', 'mkv'];

type Media = {
  type: string;
  url: string;
  name: string;
};

type Props = {
  sms: {
    media: Media[];
  };
  openImageModal?: () => void;
};

const SharedMediaRenderer: React.FC<Props> = ({ sms }) => {
  const handleClick = async (link: string) => {
    if (link) {
      window.open(link, '_blank');
    } else {
      alert('Failed to fetch file URL');
    }
  };

  if (!sms.media || sms.media.length === 0) return null;

  return (
    <>
      {sms.media.map((media, idx) => {
        const subType = media.type ? media.type.split('/')[1] : '';

        // Document
        if (DocumentsTypes.includes(subType)) {
          return (
            <div
              key={idx}
              className="bg-white p-2 rounded-lg border border-[#D7D7E3] flex items-center gap-2"
              onClick={() => handleClick(media.url)}
            >
              <DOCIcon />
              <div className="text-black text-[13px] font-medium leading-[17px]">{media.name}</div>
            </div>
          );
        }

        // Audio
        if (AudioTypes.includes(subType)) {
          return (
            <div
              key={idx}
              className="bg-white p-2 rounded-lg border border-[#D7D7E3] flex items-center gap-2"
              onClick={() => handleClick(media.url)}
            >
              <div className="flex flex-col">
                <div className="flex">
                  🎵
                  <div className="text-black text-[13px] font-medium leading-[17px]">
                    {media.name}
                  </div>
                </div>
              </div>
            </div>
          );
        }

        // Image
        if (ImageTypes.includes(subType)) {
          return (
            <SharedImage
              key={idx}
              src={media.url}
              onClick={() => handleClick(media.url)}
              fileName={media.name}
            />
          );
        }

        // Video
        if (VideoTypes.includes(subType)) {
          return (
            <div
              key={idx}
              className="bg-white p-2 rounded-lg border border-[#D7D7E3] flex items-center gap-2"
              onClick={() => handleClick(media.url)}
            >
              <VideoIcon />
              <div className="text-black text-[13px] font-medium leading-[17px]">{media.name}</div>
            </div>
          );
        }

        // Fallback (unknown type)
        return null;
      })}
    </>
  );
};

export default SharedMediaRenderer;
